import Ownership from "./routes/Ownership/Ownership.vue";
import Target from "./routes/Target/Target.vue";
import Segment from "./routes/Segment/Segment.vue";

const salesUploadRoutes = [
  {
    path: "ownership",
    name: "Ownership",
    component: Ownership,
  },
  {
    path: "target",
    name: "Target",
    component: Target,
  },
  {
    path: "segment",
    name: "Segment",
    component: Segment,
  },
  
];

export default salesUploadRoutes;
